import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { ArrowRightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Price from '@components/base/Price';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileCartBarPet() {
  const t = useCopy();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.md;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = useLocation();
  const isVisible = isMobile && lineCount > 0 && pathname !== '/cart' && pathname !== '/checkout';

  useEffect(() => {
    document.documentElement.classList.toggle('pet-mobile-cart-bar-active', isVisible);
    return () => {
      document.documentElement.classList.remove('pet-mobile-cart-bar-active');
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <aside className="pet-mobile-cart-bar" aria-label={t('cartSummary', 'Cart summary')}>
      <div className="pet-mobile-cart-bar__meta">
        <span className="pet-mobile-cart-bar__icon" aria-hidden>
          <ShoppingCartOutlined />
        </span>
        <span className="pet-mobile-cart-bar__copy">
          <strong>
            {lineCount} {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
          </strong>
          <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} />
        </span>
      </div>
      <Link to="/cart" className="pet-mobile-cart-bar__cta">
        {t('viewCart', 'View cart')} <ArrowRightOutlined />
      </Link>
    </aside>
  );
}
